import React from 'react';
import { BeforeAfter } from '../components/BeforeAfter';
export function AntesYDespues() {
  return <div className="pt-24" data-id="element-425">
      <BeforeAfter data-id="element-426" />
    </div>;
}